<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
        size="small"
        v-if="$canEdit"
        >添加
      </el-button>
      <el-input
        v-model="listQuery.username"
        placeholder="客户账号"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.name"
        placeholder="客户名称"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 90px"
        class="filter-item"
        size="small"
      >
        <el-option label="正常" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-select
        v-model="listQuery.client_category"
        placeholder="客户分类"
        clearable
        style="width: 130px"
        class="filter-item"
        size="small"
      >
        <el-option label="商旅" value="business" />
        <el-option label="OTA" value="otc" />
      </el-select>
      <el-select
        v-model="listQuery.is_open_company"
        placeholder="成员公司模式"
        clearable
        style="width: 130px"
        class="filter-item"
        size="small"
      >
        <el-option label="开放" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-select
        v-model="listQuery.is_self_use"
        placeholder="合作商自用模式"
        clearable
        style="width: 140px"
        class="filter-item"
        size="small"
      >
        <el-option label="开放" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-select
        v-model="listQuery.cooperation_type"
        placeholder="合作类型"
        clearable
        style="width: 120px"
        class="filter-item"
        size="small"
      >
        <el-option label="账期合作" value="account_term" />
        <el-option label="预充值合作" value="advance_recharge" />
        <el-option label="企业现付" value="enterprise_cash_payment" />
      </el-select>
      <el-select
        v-model="listQuery.account_term_cycle"
        placeholder="账期周期"
        clearable
        style="width: 120px"
        class="filter-item"
        size="small"
      >
        <el-option label="周结" value="weekly_settlement" />
        <el-option label="半月结" value="half_month_settlement" />
        <el-option label="月结" value="monthly_settlement" />
      </el-select>

      <el-select
        v-model="listQuery.api_account_name"
        placeholder="锦江卡"
        filterable
        clearable
        style="width: 160px"
        class="filter-item"
        size="small"
      >
        <el-option
          v-for="item in apiAccountList"
          :key="item.name"
          :label="item.name"
          :value="item.name"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="客户账号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>
      <el-table-column label="客户名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="客户全称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.full_name }}
        </template>
      </el-table-column>
      <el-table-column label="合作类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.cooperation_type === 'account_term'"
            type="primary"
            >账期合作</el-tag
          >
          <el-tag
            v-else-if="scope.row.cooperation_type === 'advance_recharge'"
            type="success"
            >预充值合作</el-tag
          >
          <el-tag
            v-else-if="scope.row.cooperation_type === 'enterprise_cash_payment'"
            type="info"
            >企业现付</el-tag
          >
          <el-tag v-else type="warning">-</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="账期周期" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.account_term_cycle === 'weekly_settlement'"
            type="primary"
            >周结</el-tag
          >
          <el-tag
            v-else-if="scope.row.account_term_cycle === 'half_month_settlement'"
            type="success"
            >半月结</el-tag
          >
          <el-tag
            v-else-if="scope.row.account_term_cycle === 'monthly_settlement'"
            type="warning"
            >月结</el-tag
          >
          <el-tag v-else type="warning">-</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact_phone }}
        </template>
      </el-table-column>
      <el-table-column label="联系邮箱" min-width="180" align="center">
        <template slot-scope="scope">
          <el-tag
            v-for="(email, index) in (scope.row.contact_email || '')
              .split(',')
              .filter(Boolean)"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ email.trim() }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal == 1" type="success">正常</el-tag>
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="成员公司模式"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_open_company == 1" type="success"
            >开放</el-tag
          >
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="合作商自用模式"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_self_use == 1" type="success">开放</el-tag>
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="App ID" min-width="110" align="center">
        <template slot-scope="scope">
          <div v-if="visibleSecrets[scope.$index]">
            {{ scope.row.app_id }}
          </div>
          <div v-else>
            <el-button
              type="text"
              @click="openPasswordPrompt(scope.$index, scope.row)"
            >
              <i class="el-icon-view"></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="App Secret" min-width="110" align="center">
        <template slot-scope="scope">
          <div v-if="visibleSecrets[scope.$index]">
            {{ scope.row.app_secret }}
          </div>
          <div v-else>
            <el-button
              type="text"
              @click="openPasswordPrompt(scope.$index, scope.row)"
            >
              <i class="el-icon-view"></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="IP白名单" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.ips || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="QPS" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.qps || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="上级渠道名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.channel ? scope.row.channel.name : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="渠道ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.channel_id || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="上级佣金比率(%)" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.channel_commission_rate * 100 || '-' }}
        </template>
      </el-table-column>
      <!--      <el-table-column label="渠道代理加价比率(%)" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.channel_price_rate * 100 || "-" }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="房源权限" min-width="180" align="center">
        <template slot-scope="scope">
          <el-tag
            v-for="(item, index) in scope.row.hotel_permissions.filter(
              (p) => p.is_enabled === 1,
            )"
            :key="index"
            type="success"
            effect="plain"
            style="margin-bottom: 3px; margin-right: 3px"
          >
            {{
              item.hotel_permissions_type === 'jin_jiang'
                ? '锦江房源'
                : item.hotel_permissions_type === 'long_teng'
                ? '龙腾房源'
                : '遂穿房源'
            }}
            <span v-if="item.channel_price_rate">
              | {{ item.channel_price_rate * 100 }}%</span
            >
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="锦江卡" min-width="250" align="center">
        <template slot-scope="scope">
          <el-tag
            v-for="(item, index) in scope.row.bind_api_accounts_show"
            :key="index"
            :type="
              item.deleted_at || item.status != 'enable' ? 'danger' : 'success'
            "
            effect="plain"
            style="margin-bottom: 3px; margin-right: 3px"
          >
            {{ item.name }}
          </el-tag>
          {{ scope.row.bind_api_accounts_show.length <= 0 ? '-' : '' }}
        </template>
      </el-table-column>
      <el-table-column label="通知配置" min-width="250" align="center">
        <template slot-scope="scope">
          <el-tag
            v-for="(item, index) in scope.row.bind_notification_configs_show"
            :key="index"
            :type="item.status === 0 ? 'danger' : 'primary'"
            effect="plain"
            style="margin-bottom: 3px; margin-right: 3px"
          >
            {{ item.name }}
            <span style="margin-left: 4px; opacity: 0.7">{{
              item.notify_type === 'email'
                ? '邮箱'
                : item.notify_type === 'sms'
                ? '短信'
                : item.notify_type === 'wechat'
                ? '微信'
                : '钉钉'
            }}</span>
          </el-tag>
          {{
            scope.row.bind_notification_configs_show &&
            scope.row.bind_notification_configs_show.length <= 0
              ? '-'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column label="客户分类" min-width="110" align="center">
        <template slot-scope="scope">{{
          scope.row.client_category == 'business' ? '商旅' : 'OTA'
        }}</template>
      </el-table-column>
      <el-table-column label="是否显示成本" min-width="110" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.is_show_cost == 1"
            @change="handleChangeShowCost(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="230"
        v-if="$canEdit"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button
            v-if="scope.row.is_normal == 1"
            type="warning"
            size="mini"
            @click="handleStatus(scope.row.id, 0)"
          >
            禁用
          </el-button>
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, 1)"
            >解禁</el-button
          >
          <div style="margin-top: 5px">
            <el-button
              size="mini"
              type="primary"
              @click="handleUpdate1(scope.row)"
              >常用信息修改
            </el-button>
            <el-button
              size="mini"
              type="warning"
              @click="initPassword(scope.row.id, 1)"
              >初始化密码</el-button
            >
          </div>
          <el-button
            size="mini"
            type="primary"
            style="margin-top: 5px"
            @click="handleBindNotification(scope.row)"
            >通知配置</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="130px"
        style="margin-left: 50px"
      >
        <el-form-item label="客户账号" prop="username">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="客户名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="客户全称" prop="full_name">
          <el-input v-model="form.full_name" />
        </el-form-item>
        <el-form-item label="合作类型" prop="cooperation_type">
          <el-select v-model="form.cooperation_type">
            <el-option label="账期合作" :value="'account_term'" />
            <el-option label="预充值合作" :value="'advance_recharge'" />
            <el-option label="企业现付" :value="'enterprise_cash_payment'" />
          </el-select>
        </el-form-item>
        <el-form-item label="账期周期" prop="account_term_cycle">
          <el-select v-model="form.account_term_cycle">
            <el-option label="周结" value="weekly_settlement" />
            <el-option label="半月结" value="half_month_settlement" />
            <el-option label="月结" value="monthly_settlement" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户分类" prop="client_category">
          <el-select v-model="form.client_category">
            <el-option label="商旅" value="business" />
            <el-option label="OTA" value="otc" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="contact_phone">
          <el-input v-model="form.contact_phone" />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contact_email">
          <el-input
            v-model="form.contact_email"
            placeholder="多个邮箱请用逗号隔开"
          />
        </el-form-item>
        <el-form-item label="上级渠道ID" prop="channel_id">
          <el-input
            v-model="form.channel_id"
            @input="getChannelData(form.channel_id)"
          />
        </el-form-item>
        <el-form-item label="渠道名称" prop="">
          {{ channel.name || '无渠道' }}
        </el-form-item>
        <el-form-item label="渠道佣金比率(%)" prop="channel_commission_rate">
          <el-input-number v-model="form.channel_commission_rate" />
        </el-form-item>
        <el-form-item label="IP白名单" prop="ips">
          <el-input v-model="form.ips" />
        </el-form-item>
        <el-form-item label="QPS" prop="qps">
          <el-input v-model="form.qps" />
        </el-form-item>
        <el-form-item label="状态" prop="is_normal">
          <el-select v-model="form.is_normal">
            <el-option label="正常" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="渠道加价比率(%)" prop="channel_price_rate">-->
        <!--          <el-input-number v-model="form.channel_price_rate"/>-->
        <!--        </el-form-item>-->
        <el-form-item label="绑定锦江账户" prop="bind_api_accounts">
          <el-select
            v-model="form.bind_api_accounts"
            multiple
            placeholder="请选择锦江账户"
          >
            <el-option
              :style="item.disabled && 'background-color: #F56C6C;color:white;'"
              v-for="item in fliterApiAccountList(form.bind_api_accounts)"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房源权限" prop="hotel_permissions">
          <div
            v-for="(item, index) in form.hotel_permissions"
            :key="index"
            style="display: flex; align-items: center; margin-bottom: 10px"
          >
            <el-checkbox
              v-model="item.is_enabled"
              :true-label="1"
              :false-label="0"
            >
              {{
                item.hotel_permissions_type === 'jin_jiang'
                  ? '锦江房源'
                  : item.hotel_permissions_type === 'long_teng'
                  ? '龙腾房源'
                  : '遂穿房源'
              }}
            </el-checkbox>
            <span style="margin-left: 12px">渠道佣金比率(%):</span>
            <el-input-number
              v-model="item.channel_price_rate"
              :min="0"
              style="margin-left: 10px; flex: 1"
              placeholder="渠道加价比率"
            />
          </div>
        </el-form-item>
        <el-form-item label="成员公司模式" prop="is_open_company">
          <el-switch
            v-model="form.is_open_company"
            active-text="开放"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="合作商自用模式" prop="is_self_use">
          <el-switch
            v-model="form.is_self_use"
            active-text="开放"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="常用信息修改"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        ref="form1"
        :rules="rules1"
        :model="form1"
        label-position="left"
        label-width="150px"
        style="margin-left: 50px"
      >
        <el-form-item label="购买方名称" prop="buyer_name">
          <el-input v-model="form1.buyer_name" />
        </el-form-item>
        <el-form-item label="购买方纳税人识别号" prop="buyer_taxpayer_no">
          <el-input v-model="form1.buyer_taxpayer_no" />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form1.address" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form1.phone" />
        </el-form-item>
        <el-form-item label="开户行" prop="bank">
          <el-input v-model="form1.bank" />
        </el-form-item>
        <el-form-item label="银行卡号" prop="bank">
          <el-input v-model="form1.bank_no" />
        </el-form-item>
        <el-form-item label="纳税人资质" prop="taxpayer_qualification_type">
          <el-select v-model="form1.taxpayer_qualification_type">
            <el-option label="小微企业" :value="1" />
            <el-option label="一般纳税人" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票类型" prop="invoicing_type">
          <el-select v-model="form1.invoicing_type">
            <el-option label="普通发票" :value="1" />
            <el-option label="专用发票" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="发送邮箱" prop="email">
          <el-input v-model="form1.email" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form1.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveData1" :loading="btnLoading1"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请输入操作密码"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form2"
        :rules="rules2"
        :model="form2"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="操作密码" prop="password">
          <el-input v-model="form2.password" type="password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="通知配置绑定"
      :visible.sync="bindDialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <div v-loading="bindBtnLoading">
        <el-checkbox-group v-model="bindSelectedIds">
          <el-checkbox
            v-for="item in notificationConfigs"
            :key="item.id"
            :label="item.id"
            style="display: flex; margin-bottom: 10px; align-items: center"
            :class="{ 'disabled-item': item.status === 0 }"
          >
            <span :style="item.status === 0 ? 'color: #F56C6C;' : ''">{{
              item.name
            }}</span>
            <el-tag
              size="mini"
              :type="item.status === 0 ? 'danger' : 'primary'"
              style="margin-left: 8px"
              >{{
                item.notify_type === 'email'
                  ? '邮箱'
                  : item.notify_type === 'sms'
                  ? '短信'
                  : item.notify_type === 'wechat'
                  ? '微信'
                  : '钉钉'
              }}</el-tag
            >
            <span
              style="margin-left: 8px; color: #999"
              :style="item.status === 0 ? 'color: #F56C6C;' : ''"
              >{{ item.notify_value }}</span
            >
          </el-checkbox>
        </el-checkbox-group>
        <div
          v-if="notificationConfigs.length === 0"
          style="text-align: center; color: #999; padding: 20px"
        >
          暂无通知配置
        </div>
      </div>
      <div slot="footer">
        <el-button @click="bindDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="saveBindNotification"
          :loading="bindBtnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import uploadList from '@/components/UploadList/index.vue'

export default {
  components: { uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
        bind_api_account_id: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      channel: { name: '' },
      form: {
        id: '',
        name: undefined,
        full_name: undefined,
        contact_phone: undefined,
        contact_email: undefined,
        channel_id: undefined,
        channel_commission_rate: undefined,
        is_normal: 1,
        ips: undefined,
        channel_price_rate: 0,
        bind_api_accounts: [],
        hotel_permissions: [
          {
            hotel_permissions_type: 'jin_jiang',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'long_teng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          },
        ],
        is_open_company: 0,
        is_self_use: 0,
      },
      rules: {
        username: [
          { required: true, message: '客户账号不能为空', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '客户名称不能为空', trigger: 'blur' },
        ],
        full_name: [
          { required: true, message: '客户全称不能为空', trigger: 'blur' },
        ],
        contact_phone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
        ],
        contact_email: [
          { required: true, message: '联系邮箱不能为空', trigger: 'blur' },
        ],
        is_normal: [
          { required: true, message: '状态不能为空', trigger: 'blur' },
        ],
        qps: [{ required: true, message: 'QPS不能为空', trigger: 'blur' }],
        hotel_permissions: [
          {
            validator: (_rule, value, callback) => {
              if (value && value.length) {
                const emptyIndex = value.findIndex(
                  (item) =>
                    item.channel_price_rate === null ||
                    item.channel_price_rate === undefined,
                )
                if (emptyIndex !== -1) {
                  callback(
                    new Error(
                      `${
                        value[emptyIndex].hotel_permissions_type === 'jin_jiang'
                          ? '锦江房源'
                          : value[emptyIndex].hotel_permissions_type === 'long_teng'
                          ? '龙腾房源'
                          : '遂穿房源'
                      }的渠道佣金比率不能为空`,
                    ),
                  )
                }
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      },
      btnLoading: false,
      dialogFormVisible1: false,
      dialogStatus1: '',
      textMap1: {
        update: '编辑',
        create: '添加',
      },
      form1: {
        app_client_id: '',
        buyer_name: undefined,
        buyer_taxpayer_no: undefined,
        address: undefined,
        phone: undefined,
        bank: undefined,
        bank_no: undefined,
        taxpayer_qualification_type: undefined,
        invoicing_type: undefined,
        email: undefined,
        remark: undefined,
      },
      rules1: {
        buyer_name: [
          { required: true, message: '购买方名称不能为空', trigger: 'blur' },
        ],
        buyer_taxpayer_no: [
          {
            required: true,
            message: '购买方纳税人识别号不能为空',
            trigger: 'blur',
          },
        ],
      },
      btnLoading1: false,
      dialogVisible2: false,
      form2: {
        id: '',
        password: undefined,
      },
      rules2: {
        password: [
          { required: true, message: '操作密码不能为空', trigger: 'blur' },
        ],
      },
      currentRow: null,
      currentIndex: null,
      visibleSecrets: [],
      apiAccountList: [],
      bindDialogVisible: false,
      notificationConfigs: [],
      bindSelectedIds: [],
      bindBtnLoading: false,
      currentBindClientId: null,
    }
  },
  created() {
    this.getApiAccountList()
    this.getList()
  },
  computed: {
    fliterApiAccountList() {
      return (bind_api_accounts) => {
        return this.apiAccountList.filter((item) => {
          // 如果item.id在bind_api_accounts中，则返回true（即使被禁用）
          if (bind_api_accounts && bind_api_accounts.includes(item.id)) {
            return true
          }
          // 否则检查是否被禁用
          return !(item.deleted_at || item.status == 'disable')
        })
      }
    },
  },
  methods: {
    openPasswordPrompt(index, row) {
      this.currentRow = row
      this.currentIndex = index
      this.form2.id = row.id
      this.dialogVisible2 = true
    },
    confirmPassword() {
      request({
        url: '/api/backend/app-client/get-secret',
        method: 'get',
        params: this.form2,
      }).then((response) => {
        this.$set(this.visibleSecrets, this.currentIndex, true)
        this.list[this.currentIndex].app_id = response.data.app_id
        this.list[this.currentIndex].app_secret = response.data.app_secret
        this.dialogVisible2 = false
      })
    },
    getChannelData(id) {
      this.channel.name = null
      request({
        url: '/api/backend/channel/detail',
        method: 'get',
        params: {
          id,
        },
      }).then((response) => {
        if (response.data) {
          this.channel = response.data
        }
      })
    },

    getApiAccountList() {
      this.channel.name = null
      request({
        url: '/api/backend/api-account/list',
        method: 'get',
        params: {
          limit: 9999999999,
          api_type: 'jin_jiang',
          is_show_delete: 1,
        },
      }).then((response) => {
        if (response.data) {
          this.apiAccountList = response.data.data.map((item) => {
            return {
              ...item,
              disabled:
                item.deleted_at || item.status != 'enable' ? true : false,
            }
          })
        }
      })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        name: undefined,
        is_normal: 1,
        ips: undefined,
        channel_price_rate: 0,
      }
      this.btnLoading = false
    },
    handleCreate() {
      this.resetForm()
      this.form = {
        ...this.form,
        hotel_permissions: [
          {
            hotel_permissions_type: 'jin_jiang',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'long_teng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          },
        ],
        is_open_company: 0,
        is_self_use: 0,
      }
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = Object.assign(
        {
          imgArray: [
            'http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png',
            'http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png',
          ],
        },
        row,
      ) // copy obj
      this.form.channel_commission_rate =
        this.form.channel_commission_rate * 100
      // this.form.channel_price_rate = this.form.channel_price_rate * 100
      console.log(this.form.hotel_permissions)

      if (
        !this.form.hotel_permissions ||
        this.form.hotel_permissions.length === 0
      ) {
        this.form.hotel_permissions = [
          {
            hotel_permissions_type: 'jin_jiang',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'long_teng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          },
        ]
      } else {
        this.form.hotel_permissions = this.form.hotel_permissions.map(
          (item) => ({
            ...item,
            channel_price_rate: item.channel_price_rate * 100,
          }),
        )
        // 确保三种房源权限都存在
        const types = this.form.hotel_permissions.map(
          (item) => item.hotel_permissions_type,
        )
        if (!types.includes('sui_chuan')) {
          this.form.hotel_permissions.push({
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          })
        }
      }

      this.getChannelData(this.form.channel_id)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          var form = JSON.parse(JSON.stringify(this.form))
          form.channel_commission_rate = form.channel_commission_rate / 100
          // form.channel_price_rate = form.channel_price_rate / 100
          form.hotel_permissions = form.hotel_permissions.map((item) => ({
            ...item,
            channel_price_rate: item.channel_price_rate / 100,
          }))
          request({
            url: '/api/backend/app-client/store',
            method: 'post',
            data: form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    handleUpdate1(row) {
      this.form1 = Object.assign({}, row.app_client_info) // copy obj
      this.form1.app_client_id = row.id
      this.dialogStatus1 = 'update'
      this.dialogFormVisible1 = true
      this.$nextTick(() => {
        this.$refs['form1'].clearValidate()
      })
    },
    saveData1() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.btnLoading1 = true
          request({
            url: '/api/backend/app-client/store-info',
            method: 'post',
            data: this.form1,
          })
            .then((response) => {
              this.btnLoading1 = false
              this.dialogFormVisible1 = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading1 = false
            })
        }
      })
    },
    handleStatus(id, isNormal) {
      this.$confirm('此操作将修改客户端状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client/change-status',
            method: 'post',
            data: { id: id, is_normal: isNormal },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    initPassword(id) {
      this.$confirm('此操作将初始化客户端密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client/init-password',
            method: 'post',
            data: { id: id },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleChangeShowCost(row) {
      const newVal = row.is_show_cost == 1 ? 0 : 1
      const label = newVal === 1 ? '显示成本' : '不显示成本'
      this.$confirm(`确定将此客户端设为"${label}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client/change-show-cost',
            method: 'post',
            data: { id: row.id, is_show_cost: newVal },
          }).then(() => {
            row.is_show_cost = newVal
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleBindNotification(row) {
      this.currentBindClientId = row.id
      this.bindSelectedIds = []
      this.bindBtnLoading = true
      this.bindDialogVisible = true
      Promise.all([
        request({
          url: '/api/backend/notification-config/list',
          method: 'get',
          params: { limit: 9999 },
        }),
        request({
          url: '/api/backend/notification-config/bindings',
          method: 'get',
          params: { app_client_id: row.id },
        }),
      ])
        .then(([listRes, bindRes]) => {
          this.notificationConfigs =
            listRes.data.data || listRes.data.items || []
          this.bindSelectedIds = bindRes.data.bound_ids || []
        })
        .finally(() => {
          this.bindBtnLoading = false
        })
    },
    saveBindNotification() {
      this.bindBtnLoading = true
      request({
        url: '/api/backend/notification-config/bind',
        method: 'post',
        data: {
          app_client_id: this.currentBindClientId,
          notification_config_ids: this.bindSelectedIds,
        },
      })
        .then(() => {
          this.bindDialogVisible = false
          this.$message({
            type: 'success',
            message: '绑定成功',
          })
          this.getList()
        })
        .finally(() => {
          this.bindBtnLoading = false
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

::v-deep(.el-form-item__content) {
  max-width: 400px;
}

.disabled-item {
  ::v-deep(.el-checkbox__label) {
    color: #f56c6c !important;
  }
}
</style>
